import React, { useContext, useEffect } from "react";
import { GlobalContext } from "../../App";
import { HomeContext } from "./Home";
import "../../styles/pages/home/PreviewPage.scss";
import { Trans, useTranslation } from "react-i18next";
import { submitForm } from "../../api/apiManagement";
function PreviewPage() {
  const { submitData, setSubmitData, setIsLoading } = useContext(GlobalContext);
  const {
    setIsPreview,
    isPreview,
    submitErrorMessage,
    setSubmitErrorMessage,
    isWaitingList,
    setCurrentStep,
  } = useContext(HomeContext);
  const { t, i18n } = useTranslation();

  useEffect(() => {}, [submitData]);
  function handleGoBackButton() {
    setIsPreview(false);
    setSubmitData((preStatus) => ({
      ...preStatus,
      action: "preview",
    }));
  }

  function dataGA() {
    window.dataLayer.push({
      event: "custom_event", // Fixed value for GA setting
      event_action: "Submit Button Click", // Fixed value for submit button click
      page_name: "Galaxy Workshop Registration Page", // Indicate which page's submit button
      workshop_name: submitData.event_name, // Dynamic value for workshop name
    });
  }

  function onSubmitData() {
    setIsLoading(true);

    submitForm(submitData)
      .then((res) => {
        const currentStatusCode = res.data.StatusCode;

        if (currentStatusCode === 200) {
          setSubmitErrorMessage("");
          setCurrentStep(1);
          dataGA();
        } else if (currentStatusCode === 201) {
          setSubmitErrorMessage("");
          setCurrentStep(2);
          dataGA();
        } else if (currentStatusCode === 501) {
          setSubmitErrorMessage(t("global:statusCode_501"));
        } else if (currentStatusCode === 502) {
          setSubmitErrorMessage(t("global:statusCode_502"));
        } else if (currentStatusCode === 503) {
          setSubmitErrorMessage(t("global:statusCode_503"));
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }
  return (
    <div className="preview-page-container">
      <div className="text-container">
        <div className="text">
          <Trans i18nKey="previewPage:submitData" />
        </div>
        {isWaitingList ? (
          <div className="waiting-list-text">
            <Trans i18nKey="previewPage:waitingList" />
          </div>
        ) : (
          <></>
        )}
      </div>
      <div className="input-row">
        <div className="input-container">
          <div className="input-label-container">
            <div className="input-label">
              <Trans i18nKey="previewPage:lastName" />
            </div>
            <div className="input-box">{submitData.last_name}</div>
          </div>
        </div>
        <div className="input-container">
          <div className="input-label-container">
            <div className="input-label">
              <Trans i18nKey="previewPage:firstName" />
            </div>
            <div className="input-box">{submitData.first_name}</div>
          </div>
        </div>
      </div>
      <div className="input-row">
        <div className="input-container">
          <div className="input-label-container">
            <div className="input-label">
              <Trans i18nKey="previewPage:mobileNumber" />
            </div>
            <div className="input-box">{submitData.phone}</div>
          </div>
        </div>
        <div className="input-container">
          <div className="input-label-container">
            <div className="input-label">
              <Trans i18nKey="previewPage:emailAddress" />
            </div>
            <div className="input-box">{submitData.email}</div>
          </div>
        </div>
      </div>
      <div className="input-row">
        <div className="input-container">
          <div className="input-label-container">
            <div className="input-label">
              <Trans i18nKey="previewPage:eventName" />
            </div>
            <div className="input-box">{submitData.event_name}</div>
          </div>
        </div>
        <div className="input-container">
          <div className="input-label-container">
            <div className="input-label">
              <Trans i18nKey="previewPage:eventLocation" />
            </div>
            <div className="input-box">{submitData.event_address}</div>
          </div>
        </div>
      </div>
      <div className="input-row">
        <div className="input-container">
          <div className="input-label-container">
            <div className="input-label">
              <Trans i18nKey="previewPage:eventDate" />
            </div>
            <div className="input-box">{submitData.workshop_date}</div>
          </div>
        </div>
        <div className="input-container">
          <div className="input-label-container">
            <div className="input-label">
              <Trans i18nKey="previewPage:eventTime" />
            </div>
            <div className="input-box">{submitData.event_time_slot}</div>
          </div>
        </div>
      </div>{" "}
      <span className="submit-error-message">{submitErrorMessage}</span>
      <div className="button-container">
        <button className="button" onClick={() => handleGoBackButton()}>
          <Trans i18nKey="previewPage:goBack" />
        </button>
        <button
          className="button submit-buttoon"
          onClick={() => onSubmitData()}
        >
          <Trans i18nKey="previewPage:submit" />
        </button>
      </div>
    </div>
  );
}

export default PreviewPage;
